import { useEffect, useRef } from "react";
import { TablesService } from "../../services/TablesService";
import ModalContainer from "../../containers/Modal/ModalContainer";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import DraggableList from "react-draggable-list";

export default function DynamicTableEditor({
  setColumns,
  tableName,
  show,
  setShow
}) {
  const [tableColumns, setTableColumns] = useState([]);
  let { t } = useTranslation();

  const containerRef = useRef();
  useEffect(() => {
    getUserTableColumns();
  }, []);

  function getUserTableColumns() {
    TablesService.getUserTableColumns(tableName).then((data) => {
      onListChange(data);
    });
  }
  function closeModal() {
    setShow(false);
  }

  function onSubmit() {
    let selectedColumns = tableColumns
      .filter((item) => item.selected)
      .map((item) => item.id);
    TablesService.saveUserTableColumns(selectedColumns, tableName).then(
      (data) => {
        onListChange(data);
        closeModal();
      }
    );
  }
  function onChange(id) {
    setTableColumns(
      tableColumns.map((item) => {
        if (item.id === id) {
          item.selected = !item.selected;
        }
        return item;
      })
    );
  }
  function resetColumns() {
    TablesService.resetUserTableColumns(tableName).then((data) => {
      onListChange(data);
    });
  }
  function template({ item, itemSelected, dragHandleProps }) {
    const { onMouseDown, onTouchStart } = dragHandleProps;
    return (
      <div
        className="row pe-4 ps-4"
        role="button"
        onTouchStart={(e) => {
          e.preventDefault();

          onTouchStart(e);
        }}
        onMouseDown={(e) => {
          e.preventDefault();
          onMouseDown(e);
        }}
      >
        <div className="form-check form-check-inline  col" key={item.id}>
          <input
            className="form-check-input"
            type="checkbox"
            id={item.id}
            name={"manager"}
            checked={item.selected}
            onChange={() => onChange(item.id)}
          />
          <label className="form-check-label" htmlFor={"column"} role="button">
            {t(item.columnName)}
          </label>
        </div>
        <div className="col-1 text-end">
          <div>
            <i class="bi bi-grip-vertical"></i>
          </div>
        </div>
      </div>
    );
  }

  function onListChange(data) {
    if (data.map((x) => x.selected).includes(true)) {
      setTableColumns(data);
      setColumns(data.filter((x) => x.selected));
    } else {
      setTableColumns(
        data.map((item) => {
          if (item.isDefault) {
            item.selected = true;
          }
          return item;
        })
      );
      setColumns(data.filter((x) => x.isDefault));
    }
  }
  return (
    <ModalContainer
      isOpen={show}
      modalTitle={t("edit columns")}
      closeModal={closeModal}
      crossmarkAction={closeModal}
      cancelButtonAction={resetColumns}
      cancelButtonTitle="Reset"
      submitButtonTitle="Save"
      modalSize="sm"
      submitButtonAction={onSubmit}
    >
      <div ref={containerRef}>
        <DraggableList
          itemKey="id"
          template={template}
          list={tableColumns}
          onMoveEnd={(newList) => onListChange(newList)}
          container={() => containerRef.current}
        />
      </div>
    </ModalContainer>
  );
}
